/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Container } from "react-awesome-styled-grid";
import { When } from "react-if";
import { Button, FlexContainer, Radio, Text, theme } from "@nordcloud/gnui";

export type RadioOptionProps = {
  option:
    | {
        label: string;
        desc: string;
        icon: JSX.Element;
      }
    | undefined;
  isChecked: boolean;
  showSettingsButton: boolean;
  onSettingsClick: () => void;
  onOptionChange: () => void;
};

export function RadioOptionTable({
  option,
  isChecked,
  showSettingsButton,
  onSettingsClick,
  onOptionChange,
}: RadioOptionProps) {
  return (
    <FlexContainer>
      <Container
        style={{
          borderTop: "none",
          padding: theme.spacing.spacing00,
          verticalAlign: "middle",
          width: "2rem",
        }}
      >
        <Radio
          id={`radio.button.${option?.label}`}
          name="radiogroup"
          value={option?.label}
          checked={isChecked}
          style={{ display: "flex", justifyContent: "center" }}
          onChange={onOptionChange}
        />
      </Container>
      <Container style={{ borderTop: "none", padding: 0, flexGrow: 1 }}>
        <Text weight="medium" style={{ margin: 0 }}>
          {option?.label}
        </Text>
        <Text tag="div" size="sm" color={theme.color.text.text02}>
          {option?.desc}
        </Text>
        <When condition={showSettingsButton}>
          <Button
            type="button"
            severity="low"
            size="md"
            data-testid="manual-cost-settings"
            css={{
              marginTop: theme.spacing.spacing02,
            }}
            onClick={onSettingsClick}
          >
            Cost Dividing Settings
          </Button>
        </When>
      </Container>
    </FlexContainer>
  );
}
